import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { userPointQueryOptions } from "~/features/purchase/api";
import { PurchasePageTemplate } from "~/features/purchase/PurchasePageTemplate";

const purchaseSearchSchema = z.object({
  /** 流入元計測用（例: "daily_bonus"）。任意。 */
  source: z.string().optional(),
  /** 初期表示する支払いタブ。バナー流入で web 決済タブを開く用途。任意。 */
  tab: z.enum(["iap", "web", "paidy"]).optional(),
  /** バナー流入時にボーナス対象カードの確認モーダルを自動表示する。任意。 */
  confirm: z.literal("bonus").optional(),
});

export const Route = createFileRoute("/_authenticated/purchase")({
  validateSearch: purchaseSearchSchema,
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(userPointQueryOptions),
  component: PurchasePageTemplate,
});
